<template>
	<div class="row mb-2">
		<div class="col">
			<form @submit.prevent="validateBeforeSubmit">
				<div class="row">
					<div class="col">
						<h5 class="mb-2 fs-20 font-weight-normal">Настройки общедоступности профиля</h5>
						<div class="boxed">
							<div class="row p-3">
								<div class="col-md-12 pb-2 pb-md-0">
									<div class="custom-control custom-switch">
										<input type="checkbox" class="custom-control-input" id="notifyEmployment" v-model="data.notify_employment">
										<label class="custom-control-label" for="notifyEmployment">Подписаться на рассылку вакансий</label>
									</div>
									<hr>
									<div class="text-muted">
										Выбирайте какие вакансии вас интересуют и мы будем информировать вас о новых
										вакансиях. Для этого запоните информацию в полях ниже.
									</div>
								</div>
							</div>
						</div>
					</div>
				</div>
				<div class="alert alert-warning mb-2">
					Выбирайте какие вакансии вас интересуют и мы будем информировать вас о новых вакансиях.
				</div>
				<div class="form-group mb-2">
					<h3 class="mb-2 fs-22 font-weight-normal">Интересующий тип вакансии</h3>
					<div>
						<label class="checkbox mr-2">
							<input type="checkbox" v-model="data.employment" name="employment[0]" :value="0">
							<span class="checkbox__circle"></span>
							<span>Полная занятость</span>
						</label>
						<label class="checkbox mr-2">
							<input type="checkbox" v-model="data.employment" name="employment[1]" :value="1">
							<span class="checkbox__circle"></span>
							<span>Частичная занятость</span>
						</label>
						<label class="checkbox">
							<input type="checkbox" v-model="data.employment" name="employment[2]" :value="2">
							<span class="checkbox__circle"></span>
							<span>Разовые задания</span>
						</label>
					</div>
				</div>
				<div class="alert alert-warning">
					Заполните данные по городу, метро или районам по которым мы будем предлагать вам вакансии.
					Вы можете указать несколько станций метро/районов
				</div>
				<div class="form-group">
					<label class="control-label" for="config-city">Город</label>
					<vue-bootstrap-typeahead
							id="config-city"
							name="city"
							:data="cityList"
							v-model="data.city"
							:serializer="s => s"
							@hit="checkCity"
							@input="checkCity"
							ref="cityInput"
					/>
				</div>

				<div class="form-group mb-4" v-if="districtShow">
					<label class="control-label" for="dt-add">Район</label>
					<div>
						<vue-bootstrap-typeahead
								id="dt-add"
								:data="districtList"
								v-model="district"
								:serializer="s => s.text"
								@hit="addElement($event, 'district')"
								ref="districtInput"
						/>
					</div>
					<div class="row mt-2">
						<div class="col">
							<div class="config-list row align-items-center" v-for="(item, index) in data.district">
								<div class="col-md-9">
									<span class="fs-22">{{item}}</span>
								</div>
								<div class="col-md-3 text-md-right">
									<span class="btn btn-dt-del text-danger p-0" @click="removeElement(index, 'district')">Удалить</span>
								</div>
							</div>
						</div>
					</div>
				</div>
				<div class="form-group mb-4" v-if="metroShow">
					<label class="control-label" for="config-metro">
						Метро
					</label>
					<div>
						<vue-bootstrap-typeahead
								id="config-metro"
								:data="metroList"
								v-model="metro"
								:serializer="s => s.text"
								@hit="addElement($event, 'metro')"
								ref="metroInput"
						/>
					</div>
					<div class="row mt-2">
						<div class="col">
							<div class="config-list row align-items-center" v-for="(item, index) in data.metro">
								<div class="col-md-9">
									<span class="fs-22">{{item}}</span>
								</div>
								<div class="col-md-3 text-md-right">
									<span class="btn btn-dt-del text-danger p-0" @click="removeElement(index, 'metro')">Удалить</span>
								</div>
							</div>
						</div>
					</div>
				</div>
				<div class="alert alert-warning mb-2">
					Указывайте магазины в которых вы уже работаете. Мы покажем ваш отклик работодателю в числе
					первых по вакансиям в магазинах где вы уже работаете.
				</div>
				<div class="form-group mb-3">
					<label class="control-label" for="n-add">Сеть</label>
					<div class="mb-3">
						<vue-bootstrap-typeahead
								id="n-add"
								:data="networkList"
								v-model="network"
								:serializer="s => s.text"
								@hit="[networkSelect = $event, $refs.networkInput.inputValue = '']"
								placeholder="Укажите название сети"
								:inputClass="!data.city.trim().length ? 'disabled' : ''"
								ref="networkInput"
						/>
					</div>
					<div v-if="networkSelect" class="config-list row align-items-center network-el mb-3">
						<div class="col-md-12">
							<div class="fs-22 mb-1">{{networkSelect.text}}</div>
							<vue-bootstrap-typeahead
									inputClass="form-control border-danger mb-1"
									:data="addressList"
									v-model="address"
									:serializer="s => s.text"
									@hit="addElement($event, 'address')"
									ref="addressInput"
							/>
							Начните вводить адрес сетевого магазина
						</div>
					</div>
					<div class="row mt-2">
						<div class="col">
							<div class="config-list row align-items-center" v-for="(item, index) in data.address">
								<div class="col-md-9">
									<span class="fs-22">{{item.network}}</span>
									<br>
									<span class="text-muted m-0">{{item.text}}</span>
								</div>
								<div class="col-md-3 text-md-right">
									<span class="btn btn-dt-del text-danger p-0" @click="removeElement(index, 'address')">Удалить</span>
								</div>
							</div>
						</div>
					</div>
				</div>
				<b-alert v-if="updated" variant="success" show dismissible>Данные успешно сохранены</b-alert>
				<div class="form-row mt-3 mb-2 align-items-center">
					<div class="col-3">
						<button type="submit" class="btn btn-secondary">Сохранить</button>
					</div>
				</div>
				<div class="alert alert-warning">
					<p>Вы можете приглашать своих друзей на платформу, отправляя им эту ссылку. Если человек за полгода
						устроиться на любую вакансию ( не задание) с сайта, то вы получаете 1000 рублей, а он за выход
						на
						работу и отработку 3 дней получает 500 рублей.
					</p>
					<strong>Реферальная ссылка:</strong>
					{{dataUser.invite_url}}
				</div>
			</form>
		</div>
	</div>
</template>

<script>
	import {mapFields} from 'vee-validate';
	import cityMixin from '../../../mixins/cityMixin'
	import {mapGetters, mapActions} from 'vuex';
	import VueBootstrapTypeahead from 'vue-bootstrap-typeahead';

	export default {
		name: "ProfileConfigAdd",
		components: {VueBootstrapTypeahead},
		data() {
			return {
				metro: '',
				district: '',
				network: '',
				address: '',

				networkSelect: null,
				metroShow: false,
				districtShow: true,

				cityList: [],
				metroList: [],
				districtList: [],
				networkList: [],
				addressList: [],

				cityWithMetro: ['екатеринбург', 'казань', 'москва', 'нижний новгород', 'новосибирск', 'самара', 'санкт-петербург'],

				data: {
					city: '',
					metro: {},
					district: {},
					address: {},
					employment: [],
					notify_employment: 0,
				},

				updated: false,
			}
		},
		methods: {
			validateBeforeSubmit() {
				this.updated = false;

				this.$validator.validateAll().then((result) => {
					if (result) {
						let address = {};
						for (let key in this.data.address) {
							let item = this.data.address[key];
							if (!address.hasOwnProperty(item.networkId)) {
								address[item.networkId] = [];
							}

							address[item.networkId].push(this.data.address[key].id);
						}

						let data = {
							city: this.data.city,
							metro: Object.keys(this.data.metro),
							district: Object.keys(this.data.district),
							networks: address,
							employment: this.data.employment,
							notify_employment: this.data.notify_employment,
						};

						this.LOCATION(data)
							.then(data => {
								this.updated = data.ok;
							});
					}
				});
			},
			checkCity() {
				if (this.cityWithMetro.indexOf(this.data.city.toLowerCase()) >= 0) {
					this.districtShow = false;
					this.metroShow = true;
				} else {
					this.metroShow = false;
					this.districtShow = true;
				}

				if (this.data.city.trim().length <= 0) {
					this.$refs.networkInput.$el.setAttribute('disabled', '');
				}
			},
			addElement(e, type) {
				switch (type) {
					case 'metro':
						this.data.metro[e.id] = e.text;
						this.$refs.metroInput.inputValue = '';
						break;
					case 'district':
						this.data.district[e.id] = e.text;
						this.$refs.districtInput.inputValue = '';
						break;
					case 'address':
						this.data.address[e.id] = {
							id: e.id,
							text: e.text,
							network: e.network,
							networkId: e.networkId
						};

						this.$refs.addressInput.inputValue = '';
						this.networkSelect = null;
						break;
				}
			},
			removeElement(id, type) {
				switch (type) {
					case 'metro':
						this.$delete(this.data.metro, id);
						break;
					case 'district':
						this.$delete(this.data.district, id);
						break;
					case 'address':
						this.$delete(this.data.address, id);
						break;
				}
			},
			loadMetroList(city, query) {
				this.METRO_LIST({city: city, q: query}).then(res => {
					const resultArray = [];
					for (let key in res.body) {
						resultArray.push({id: key, text: res.body[key]});
					}

					this.metroList = resultArray;
				});
			},
			loadCityList(query) {
				this.CITY_LIST(query).then(res => {
					const resultArray = [];
					for (let key in res.body) {
						resultArray.push(res.body[key])
					}

					this.cityList = resultArray;
				});
			},
			loadDistrictList(city, query) {
				this.DISTRICT_LIST({city: city, q: query}).then(res => {
					const resultArray = [];
					for (let key in res.body) {
						resultArray.push({id: key, text: res.body[key]});
					}

					this.districtList = resultArray;
				});
			},
			loadNetworkList(query) {
				if (!this.data.city) {
					return false;
				}

				this.NETWORK_LIST(query).then(res => {
					const resultArray = [];
					for (let key in res.body) {
						resultArray.push({id: key, text: res.body[key]})
					}

					this.networkList = resultArray;
				});
			},
			loadAddressList(city, query) {
				if (this.networkSelect === null) {
					return false;
				}

				this.ADDRESS_LIST({city: city, network: this.networkSelect.id, q: query}).then(res => {
					const resultArray = [];
					for (let key in res.body) {
						resultArray.push({
							id: key,
							text: res.body[key],
							networkId: this.networkSelect.id,
							network: this.networkSelect.text
						})
					}

					this.addressList = resultArray;
				});
			},
			...mapActions({
				DISTRICT_LIST: 'lists/DISTRICT_LIST',
				METRO_LIST: 'lists/METRO_LIST',
				CITY_LIST: 'lists/CITY_LIST',
				NETWORK_LIST: 'lists/NETWORK_LIST',
				ADDRESS_LIST: 'lists/ADDRESS_LIST',
				LOCATION: 'profile/LOCATION',
			}),
		},
		computed: {
			...mapFields({
				cityFlags: 'city'
			}),
			...mapGetters({
				dataUser: 'profile/dataUser'
			}),
		},
		mounted() {
			this.$set(this.data, 'city', this.dataUser.city ? this.dataUser.city : '');
			this.$refs.cityInput.inputValue = this.data.city;
			this.$set(this.data, 'metro', Object.keys(this.dataUser.metro).length ? this.dataUser.metro : {});
			this.$set(this.data, 'district', this.dataUser.hasOwnProperty('district') ? this.dataUser.district : {});
			this.$set(this.data, 'notify_employment', this.dataUser.notify_employment);
			this.$set(this.data, 'employment', this.dataUser.employment ? this.dataUser.employment : []);
			this.checkCity();
			let networks = {};

			for (let key in this.dataUser.networks) {
				let item = this.dataUser.networks[key];

				for (let k in item.address) {
					networks[k] = {
						id: k,
						text: item.address[k],
						network: item.name,
						networkId: item.id,
					};
				}
			}

			this.$set(this.data, 'address', networks);
		},
		mixins: [cityMixin],
		watch: {
			'modelCity': function (val) {
				this.$set(this.data, 'city', val);
				this.$refs.cityInput.inputValue = val;
			},
			'data.city': _.debounce(function (addr) {
				this.loadCityList(addr)
			}, 500),
			'metro': _.debounce(function (addr) {
				this.loadMetroList(this.data.city, addr)
			}, 500),
			'district': _.debounce(function (addr) {
				this.loadDistrictList(this.data.city, addr)
			}, 500),
			'network': _.debounce(function (addr) {
				this.loadNetworkList(addr)
			}, 500),
			'address': _.debounce(function (addr) {
				this.loadAddressList(this.data.city, addr)
			}, 500),
		}
	}
</script>

<style lang="scss">
	.dropdown-input {
		position: absolute;
		z-index: 10;
		top: calc(100% + 2px);
		left: 0;
		width: 100%;
		padding: 10px 0;
		background-color: #fff;
		border: 1px solid rgba(0, 0, 0, .15);
		border-radius: 2em;
		box-shadow: 0 6px 12px rgba(0, 0, 0, .175);
		overflow: hidden;

		li {
			display: block;
			padding: 3px 20px;
			clear: both;
			font-weight: 400;
			line-height: 1.4;
			font-size: 14px;
			color: #333;
			white-space: nowrap;
			cursor: pointer;

			&:hover {
				background-color: #f5f5f5;
			}
		}
	}

	.config-list {
		transition: all 0.2s;
		transition-delay: 0s;
		border-radius: 0.25rem;
		padding: 30px 15px;
		margin: 0;
		background: rgba(0, 0, 0, 0.1);

		&:hover {
			background: rgba(0, 0, 0, 0.2);
		}
		&:not(:last-child) {
			margin-bottom: 10px !important;
		}
		& > * {
			margin: 0;
		}
	}

	.custom-switch {
		padding-left: 3.75rem;

		& label {
			cursor: pointer;
			position: relative;
			margin-bottom: 0;
			vertical-align: top;
			line-height: 24px;
		}
		& .custom-control-label::before {
			width: 3rem;
			pointer-events: all;
			border-radius: 200px;
			height: 1.5rem;
			left: -3.75rem;
			top: 0;
		}
		& .custom-control-label::after {
			top: calc(0.25rem + 2px);
			left: calc(-4.5rem + 2px);
			width: 1rem;
			height: 1rem;
			background-color: #adb5bd;
			border-radius: 200px;
			transition: transform 0.15s ease-in-out, background-color 0.15s ease-in-out, border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;
		}
		& .custom-control-label::after {
			top: 0.25rem;
			left: -3.375rem;
			background-color: white;
			border: 1px solid #dee2e6;
		}
		@media (prefers-reduced-motion: reduce) {
			& .custom-control-label::after {
				transition: none;
			}
		}
		& .custom-control-input:checked ~ .custom-control-label::after {
			background-color: #fff;
			transform: translateX(2rem);
		}
		& .custom-control-input:disabled:checked ~ .custom-control-label::before {
			background-color: rgba(55, 85, 190, 0.5);
		}
		& .custom-control-input:checked ~ .custom-control-label::after {
			transform: translateX(1.25rem);
			border-color: white;
		}
	}
</style>
